import { Component, OnInit } from '@angular/core';
import { BaseAuthComponent } from '../../../../layouts/guest/pages/home/components/base-auth.component';
import { Error } from '@shared/interfaces/error.interface';
import { TokenParams } from '@shared/interfaces/auth/token-params.interface';
import { User } from '@shared/models/user/user.model';
import { switchMap, tap } from 'rxjs';
import { Response } from '@shared/models/response.model';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
})
export class ConfirmEmailComponent extends BaseAuthComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    const subRouter = this.activatedRoute.queryParams.subscribe((params: TokenParams) => {
      if (params.token) {
        // logout after click on verification email link
        // this.storage.delete(StorageService.SESSION_COOKIE);
        // this.storage.delete(StorageService.SESSION_REFRESH_COOKIE);
        // this.storage.delete(StorageService.USER_COOKIE);
        this.confirmEmail(params);
      } else {
        setTimeout(() => this.router.navigate([]));
      }
    });
    this.someSubscriptions.add(subRouter);
  }

  confirmEmail(confirmEmailData: TokenParams) {
    this.loading = true;
    const pack: TokenParams = { token: confirmEmailData.token };

    const subConfirmEmail = this.authService
      .confirmEmailData(pack)
      .pipe(
        switchMap(() => this.authService.userData()),
        tap((resUser: Response<User>) => {
          const user = new User(resUser.data);
          this.storage.setUser(user);

          this.toast.success(
            this.translate.instant('AUTH.account_was_activated'),
            this.translate.instant('AUTH.activation_account')
          );

          this.loading = false;
        })
      )
      .subscribe({
        next: () => {
          setTimeout(() =>
            this.router.navigate([], {
              queryParams: { token: null },
              queryParamsHandling: 'merge',
            })
          );
        },
        error: this.onConfirmEmailError.bind(this),
      });

    this.someSubscriptions.add(subConfirmEmail);
  }

  onConfirmEmailError(error: Error) {
    this.loading = false;
    this.toast.error(
      this.translate.instant('AUTH.account_not_active'),
      this.translate.instant('AUTH.activation_failed')
    );
    setTimeout(() =>
      this.router.navigate([], { queryParams: { token: null }, queryParamsHandling: 'merge' })
    );
  }
}
